import { render, staticRenderFns } from "./CustomerContactListItem.vue?vue&type=template&id=240af4d3&scoped=true&"
import script from "./CustomerContactListItem.vue?vue&type=script&lang=ts&"
export * from "./CustomerContactListItem.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerContactListItem.vue?vue&type=style&index=0&id=240af4d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240af4d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VImg,VListItem,VListItemAction,VListItemContent})
